
const gridSelector = ".collection-page__loop";
const cardSelector = ".collection-page__product";
const injectedClass = "promo-block-injected-dynamic";

const MIME_BY_EXT = {
    webm: "video/webm",
    mp4: "video/mp4",
    m4v: "video/mp4",
    ogv: "video/ogg",
    ogg: "video/ogg",
    mov: "video/quicktime",
    qt: "video/quicktime"
};

function mimeFromUrl(url) {
    const path = String(url).split("?")[0].split("#")[0].toLowerCase();
    const ext = path.split(".").pop();
    return MIME_BY_EXT[ext] || "";
}

function mimeRank(mime) {
    if (mime === "video/webm") return 0;
    if (mime === "video/mp4") return 1;
    if (mime.indexOf("mpegurl") > -1) return 3;
    return 2;
}

function shopifyMasterImageUrl(url) {
    if (!url) return url;
    return String(url).replace(
        /(_\d*x\d*)(@\d+x)?(\.[a-zA-Z0-9]+)(\?.*)?$/,
        (match, size, retina, ext, query) => `${ext}${query || ""}`
    );
}

function buildVideoSources(blockData) {
    const seen = {};
    const sources = [];

    (blockData.video_sources || []).forEach((s) => {
        if (!s || !s.url) return;
        const url = String(s.url).trim();
        if (!url || seen[url]) return;
        seen[url] = true;
        const mime = s.mime_type || mimeFromUrl(url);
        sources.push({ url: url, mime: mime, rank: mimeRank(mime.toLowerCase()) });
    });

    return sources
        .map((s, i) => ({ s: s, i: i }))
        .sort((a, b) => a.s.rank - b.s.rank || a.i - b.i)
        .map(({ s }) => `<source src="${s.url}"${s.mime ? ` type="${s.mime}"` : ""}>`)
        .join("");
}

function createPromoBlockElement(blockData) {
    const div = document.createElement("div");
    div.className = `collection-page__product collection-page__promo-block promo-block-${blockData.block_type}`;
    div.setAttribute("data-promo-id", blockData.id);
    div.setAttribute("data-promo-position", blockData.position);
    div.style.gridColumn = `span ${blockData.columns}`;
    div.style.position = "relative";
    div.style.overflow = "hidden";
    div.style.aspectRatio = "16 / 9";
    div.style.backgroundColor = "#f2f2f2";

    let mediaHTML = "";
    if (blockData.block_type === "image" && blockData.image_url) {
        mediaHTML = `
        <div class="promo-block__media" style="width: 100%; height: 100%; overflow: hidden;">
          <img class="promo-block__image"
              src="${shopifyMasterImageUrl(blockData.image_url)}"
              alt="${blockData.title}"
              loading="eager" fetchpriority="high" decoding="async"
              style="width: 100%; height: 100%; object-fit: cover; display: block;">
        </div>
      `;
    } else if (blockData.block_type === "video") {
        const sourcesHTML = buildVideoSources(blockData);
        if (sourcesHTML) {
            mediaHTML = `
          <div class="promo-block__media" style="width:100%;height:100%;overflow:hidden;">
            <video class="promo-block__video" autoplay loop muted playsinline webkit-playsinline
              preload="metadata" disablepictureinpicture disableremoteplayback
              tabindex="-1" aria-hidden="true"
              ${blockData.video_poster ? `poster="${blockData.video_poster}"` : ""}
              style="width:100%;height:100%;object-fit:cover;display:block;">
              ${sourcesHTML}
            </video>
          </div>
        `;
        }
    }

    const overlayHTML = blockData.overlay_opacity > 0 ? `
      <div class="promo-block__overlay" 
           style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; 
                  background-color: ${blockData.overlay_color}${Math.round(blockData.overlay_opacity * 2.55).toString(16).padStart(2, '0')};
                  z-index: 1;"></div>
    ` : "";

    const contentHTML = (blockData.title || blockData.text) ? `
      <div class="promo-block__content" 
           style="border-color: ${blockData.border_color}; position: absolute; bottom: 0; left: 0; right: 0; padding: 24px; z-index: 2;
                  background: linear-gradient(to top, rgba(0,0,0,0.5), transparent);">
        ${blockData.title ? `
          <h3 class="promo-block__title" 
              style="color: ${blockData.text_color}; margin: 0 0 12px 0; font-size: 24px; font-weight: 700;
                     text-transform: uppercase; letter-spacing: 2px; line-height: 1.2;">
            ${blockData.title}
          </h3>
        ` : ""}
        ${blockData.text ? `
          <div class="promo-block__text" 
               style="color: ${blockData.text_color}; margin: 0; font-size: 14px; line-height: 1.6;">
            ${blockData.text}
          </div>
        ` : ""}
      </div>
    ` : "";

    const linkHTML = blockData.link ? `
      <a href="${blockData.link}" class="promo-block__link" 
         style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 3; text-decoration: none;"></a>
    ` : "";

    div.innerHTML = mediaHTML + overlayHTML + contentHTML + linkHTML;
    div.classList.add(injectedClass);
    return div;
}

function hasActiveFilters(search) {
    return Array.from(new URLSearchParams(search).keys()).some((key) => key.startsWith("filter."));
}

function injectPromoBlocks() {
    const grid = document.querySelector(gridSelector);
    if (!grid || !window.promoBlocksData || window.promoBlocksData.length === 0) {
        return;
    }

    // Promo tiles are for the unfiltered collection only; facets.js updates the URL before
    // re-rendering the grid and calling this, so the check holds for Apply, Clear and refresh.
    if (hasActiveFilters(window.location.search)) {
        grid.querySelectorAll(`.${injectedClass}`).forEach((block) => block.remove());
        return;
    }

    const allItems = grid.querySelectorAll(cardSelector);
    const totalItems = allItems.length;

    window.promoBlocksData.forEach((blockData) => {
        const position = blockData.position;

        const alreadyInjected = grid.querySelector(
            `.${injectedClass}[data-promo-id="${blockData.id}"]`
        );

        if (alreadyInjected) return;

        if (position <= totalItems) {
            const targetItem = allItems[position - 1];

            if (targetItem && !targetItem.classList.contains("collection-page__promo-block")) {
                const promoElement = createPromoBlockElement(blockData);
                targetItem.parentNode.insertBefore(promoElement, targetItem);
            }
        }
    });
}

(function earlyInject() {
    if (document.querySelector(gridSelector)) {
        injectPromoBlocks();
    } else {
        setTimeout(earlyInject, 50);
    }
})();

window.injectPromoBlocks = injectPromoBlocks;